"use client";

import { Command } from "cmdk";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";
import { SearchIcon } from "../icons";
import { useComboboxContext } from "./context";

export type ComboboxInputProps = ComponentProps<typeof Command.Input>;

const Input = ({ ref, className, placeholder, onValueChange, ...props }: ComboboxInputProps) => {
  const { notifySearchChanged } = useComboboxContext();

  return (
    <div id="combobox-search" className="w-full p-2">
      <div className="flex h-11 w-full items-center gap-2 rounded-lg border border-neutral-80 bg-white p-3 text-neutral-10 focus-within:border-primary-80 focus-within:shadow-input lg:w-auto">
        <SearchIcon className="h-5 w-5 min-w-5 text-neutral-50" />
        <Command.Input
          ref={ref}
          className={cn(
            "w-full border-none p-0 text-sm outline-hidden placeholder:text-neutral-70 focus:ring-0 focus:outline-hidden",
            className
          )}
          placeholder={placeholder}
          onValueChange={search => {
            // Fires on typing in both the controlled and uncontrolled search modes: reset the cursor so
            // the list snaps back to the first match for the new term.
            notifySearchChanged();
            onValueChange?.(search);
          }}
          {...props}
        />
      </div>
    </div>
  );
};

Input.displayName = Command.Input.displayName;

export default Input;
